import "./locationCriticalDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../../../../shared/services";

interface LocationCriticalDetailsViewComponentProps {
    locationCriticalDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LocationCriticalDetailsViewComponent = (props: LocationCriticalDetailsViewComponentProps) => {
    const {locationCriticalDetails, onEditModeOpen, canEdit} = props;

    return (
        <div className={'location-critical-details-view-component details-tab-data-content'}>
            <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Critical Details</div>
                    {
                        canEdit && <div className={'edit-action-button'}>
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"After Hours Contact Number"}> {CommonService.getMaskedMobileNumber(locationCriticalDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Fax Number"}> {CommonService.getMaskedMobileNumber(locationCriticalDetails?.faxNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Email ID"}> {locationCriticalDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                </div>
            </>
        </div>
    );

};

export default LocationCriticalDetailsViewComponent;
